(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-score/assets/javascripts/coupon-score.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-score/assets/javascripts/coupon-score.js');
"use strict";


const Paper = svs.ui.ReactPaper;
const Coupon = svs.components.tipsen.couponComponents.Coupon;
const CouponRows = svs.components.tipsen.couponScore.CouponRows;
const CouponScore = () => React.createElement(Paper, {
  "aria-label": "Kupong",
  branding: "sport",
  className: "coupon",
  Component: "section"
}, React.createElement(Coupon, null, React.createElement(CouponRows, null)));
setGlobal('svs.components.tipsen.couponScore.CouponScore', CouponScore);

 })(window);